import { render } from "./a-item.vue?vue&type=template&id=f6c7804a"
import script from "./a-item.vue?vue&type=script&lang=js"
export * from "./a-item.vue?vue&type=script&lang=js"

import "./a-item.vue?vue&type=style&index=0&id=f6c7804a&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__